import { useState, useEffect } from 'react';

export interface CryptoPrices {
    BTC: number;
    ETH: number;
    USDT: number;
}

export interface CryptoPriceData {
    price: number;
    change: number; // percentage
}

export const useCryptoPrices = () => {
    const [prices, setPrices] = useState<Record<string, CryptoPriceData>>({
        BTC: { price: 0, change: 0 },
        ETH: { price: 0, change: 0 },
        USDT: { price: 0, change: 0 },
        BERA: { price: 0, change: 0 }
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPrices = async () => {
            try {
                const res = await fetch('https://api.upbit.com/v1/ticker?markets=KRW-BTC,KRW-ETH,KRW-USDT,KRW-BERA');
                const data = await res.json();

                const newPrices: Record<string, CryptoPriceData> = {};
                data.forEach((item: any) => {
                    const symbol = item.market.replace('KRW-', '');
                    newPrices[symbol] = {
                        price: Math.round(item.trade_price),
                        change: parseFloat((item.signed_change_rate * 100).toFixed(2))
                    };
                });

                setPrices(newPrices);
                setLoading(false);
            } catch (error) {
                console.error('Price fetch error:', error);
                setLoading(false);
            }
        };

        // Initial fetch
        fetchPrices();

        // Update every 5 seconds
        const interval = setInterval(fetchPrices, 5000);

        return () => clearInterval(interval);
    }, []);

    return { prices, loading };
};
